module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'fields',
		'tag-picker-button'
	]
}